import { Link } from 'react-router-dom';

export default function GalleryHero() {
  return (
    <section className="relative h-[50vh] md:h-[60vh] min-h-[360px] md:min-h-[480px] flex items-center justify-center overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage: 'url("https://public.readdy.ai/ai/img_res/71f35ba3473a67268c62227a06609a34.jpg")'
        }}
      ></div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-neutral-950"></div>

      <div className="absolute top-4 left-4 right-4">
        <div className="flex gap-2">
          <div className="w-16 h-0.5 bg-white/60"></div>
          <div className="w-16 h-0.5 bg-white/60"></div>
        </div>
      </div>

      <div className="relative z-10 w-full max-w-6xl mx-auto px-4 md:px-8 text-center">
        <nav className="flex items-center justify-center gap-2 text-xs md:text-sm text-neutral-400 mb-6 md:mb-8">
          <Link to="/" className="hover:text-white transition-colors cursor-pointer">Inicio</Link>
          <i className="ri-arrow-right-s-line text-neutral-600"></i>
          <span className="text-amber-500">Galería Arte Urbano</span>
        </nav>

        <div className="inline-block border border-amber-600 px-5 py-2 mb-8">
          <span className="text-amber-500 text-xs font-bold uppercase tracking-widest">Colección Completa</span>
        </div>

        <h1
          className="text-[44px] sm:text-[60px] md:text-[80px] lg:text-[100px] leading-none font-bold text-white mb-4 md:mb-6"
          style={{ fontFamily: 'Bebas Neue, sans-serif', letterSpacing: '4px' }}
        >
          GALERÍA DE<br />
          <span className="text-amber-500">ARTE URBANO</span>
        </h1>

        <p className="text-neutral-300 text-sm md:text-lg max-w-2xl mx-auto leading-relaxed px-2">
          Explora la colección completa de obras de arte urbano de Daro. Esculturas, pinturas, stencils y más — cada pieza cuenta una historia única.
        </p>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-line text-white text-2xl"></i>
      </div>
    </section>
  );
}
